exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.textarea{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.textarea *{padding:.5rem}.textarea label{font-size:1rem;color:#555;padding-left:0}.textarea textarea{background-color:#fff;height:4rem;font-size:1rem;border:1px solid #96a7bb;resize:none}@media (max-width:599px){.textarea textarea{height:2rem}}.textarea textarea::-webkit-input-placeholder{color:#ccc;font-family:Lato,sans-serif;font-weight:400}.textarea textarea::-moz-placeholder{color:#ccc;font-family:Lato,sans-serif;font-weight:400}.textarea textarea:-ms-input-placeholder{color:#ccc;font-family:Lato,sans-serif;font-weight:400}.textarea textarea:-moz-placeholder{color:#ccc;font-family:Lato,sans-serif;font-weight:400}.textarea textarea:focus{outline:none!important;border:1px solid #3fafd7;box-shadow:0 0 10px #3fafd7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/textarea/styles.scss
// module id = 1036
// module chunks = 0